module.exports = __webpack_public_path__ + "img/secondary_6x1.ba2b1400.svg";